import React from "react";
import { DataTable, Tooltip } from "@sscs/ui";
import { useAppSelector } from "Hooks";
import { selectDeletedVersions } from "Store/projects.slice";
import { Version } from "Types";
import styles from "./releasesList.module.scss";
import VersionDetails from "./VersionDetails";
import VersionSummary from "./VersionSummary";

type VersionRowProps = {
  rowIndex: number;
  version: Version;
  predecessor?: Version;
  inCatalog: boolean;
  attachedToExternalCatalog: boolean;
  isOnlyApprovedVersion: boolean;
  focusedRowID: string | null;
  onFocusChange: (id: string | null) => void;
  onDerive: () => void;
};

const VersionRow = ({
  rowIndex,
  version,
  predecessor,
  inCatalog,
  attachedToExternalCatalog,
  isOnlyApprovedVersion,
  focusedRowID,
  onFocusChange,
  onDerive,
}: VersionRowProps) => {
  const deletedVersions = useAppSelector(selectDeletedVersions);
  const isDeleted = deletedVersions.some(
    (item) => item.id === version.version_id,
  );

  return (
    <>
      <Tooltip
        key={version.version_id}
        title="Version has been deleted by another user"
        disabled={!isDeleted}
      >
        <DataTable.ExpandedRow
          id={`expand-row-${rowIndex}`}
          disabled={
            version.artifacts_summary.version.latest_report_summary
              ?.report_id === undefined || isDeleted
          }
          focused={focusedRowID === version.version_id}
          onClick={() => onFocusChange(version.version_id)}
          emphasizeExpanded={false}
          className={isDeleted ? styles.deleted : ""}
        >
          <VersionSummary
            rowIndex={rowIndex}
            version={version}
            predecessorVersion={predecessor?.software_info.version}
            inCatalog={inCatalog}
            attachedToExternalCatalog={attachedToExternalCatalog}
            isOnlyApprovedVersion={isOnlyApprovedVersion}
            onDerive={onDerive}
          />

          <DataTable.ExpandedRow.Details>
            <VersionDetails
              rowIndex={rowIndex}
              version={version}
              predecessor={predecessor}
              attachedToExternalCatalog={attachedToExternalCatalog}
              predecessorDeleted={
                predecessor
                  ? deletedVersions.some(
                      (item) => predecessor.version_id === item.id,
                    )
                  : false
              }
            />
          </DataTable.ExpandedRow.Details>
        </DataTable.ExpandedRow>
      </Tooltip>
    </>
  );
};

export default VersionRow;
